module.exports = __webpack_public_path__ + "static/media/dress-3.ee8158e9.jpg";